<template>
  <div>
    <b-modal
      :id="`modal-pay-nicu-patient-${doctorId}-${paymentStatus}`"
      :no-close-on-backdrop="true"
      :title="$t('surgery.pay-doctor')"
      ok-only
      :ok-title="$t('surgery.pay-doctor')"
      @ok="payNICUPatient()"
    >
      <b-card-text>
        <h5>{{ $t("surgery.pay-doctor") }}</h5>
        {{
          $t(
            "surgery.Are you sure do you want to pay doctor for this NICU patient"
          )
        }}
      </b-card-text>
    </b-modal>
    <b-modal
      :id="`modal-pay-all-nicu-patients-${doctorId}-${paymentStatus}`"
      :no-close-on-backdrop="true"
      :title="$t('surgery.pay-doctor')"
      ok-only
      :ok-title="$t('surgery.pay-doctor')"
      @ok="payAllNICUPatients()"
    >
      <b-card-text>
        <h5>{{ $t("surgery.pay-all-doctor-nicu") }}</h5>
        {{
          $t(
            "surgery.Are you sure you want to pay doctor for all NICU patients"
          )
        }}
        <div v-if="nicuTotals">
          <div>
            {{ $t("hospital.doctorTotalPrices") }} :
            {{ formatIQDCurrency(nicuTotals.total_price || 0) }}
          </div>
        </div>
      </b-card-text>
    </b-modal>
    <!-- ReDistribution Modal -->
    <b-modal
      :id="`modal-redistribution-nicu-${doctorId}-${paymentStatus}`"
      :no-close-on-backdrop="true"
      :title="$t('accounting.reDistribution')"
      :ok-title="$t('common.confirm')"
      :cancel-title="$t('common.cancel')"
      @ok="confirmReDistribution()"
      @cancel="cancelReDistribution()"
    >
      <b-card-text>
        <h5>{{ $t("accounting.reDistribution") }}</h5>
        <p>{{ $t("accounting.reDistribution-confirmation") }}</p>
        <b-form-group
          :label="$t('accounting.reason')"
          label-for="redistribution-reason-nicu"
        >
          <b-form-textarea
            id="redistribution-reason-nicu"
            v-model="redistributionReason"
            :placeholder="$t('accounting.reason-placeholder')"
            rows="3"
            required
          />
        </b-form-group>
      </b-card-text>
    </b-modal>

    <div
      class="d-flex align-items-center my-3"
    >
      <div
        class="flex-grow-1"
        style="border-top: 3px solid rgba(0, 0, 0, 0.1)"
      />
      <div class="mx-3" style="color: rgba(0, 0, 0, 0.3)">
        <feather-icon icon="ScissorsIcon" size="20" />
      </div>
      <div
        class="flex-grow-1"
        style="border-top: 3px solid rgba(0, 0, 0, 0.1)"
      />
    </div>
    <h1 class="text-center mb-3">
      {{ $t("incubator.nicu-patients") }}
    </h1>
    <div>
      <b-row v-if="paymentStatus === 0" class="mb-3">
        <b-col>
          <h4 class="mb-1">
            {{ $t("hospital.total_price_for_unpaid_nicu") }}:
          </h4>
          <b-badge variant="primary">{{
            formatIQDCurrency((nicuTotals && nicuTotals.total_price) || 0)
          }}</b-badge>
        </b-col>
      </b-row>

      <b-row class="d-flex justify-content-end mb-2">
        <b-col lg="2">
          <b-form-group :label="$t('hospital.patient-name')" label-for="Name">
            <b-form-input
              id="Name"
              v-model="name"
              :placeholder="$t('hospital.patient-name')"
            />
          </b-form-group>
        </b-col>
        <b-col lg="2">
          <b-form-group :label="$t('common.from')" label-for="entry_date">
            <datepicker
              v-model="from"
              :calendar-button="true"
              :clear-button="true"
              :bootstrap-styling="true"
              class="datebtn2"
              placeholder="YYYY-MM-DD"
            />
          </b-form-group>
        </b-col>
        <b-col lg="2">
          <b-form-group :label="$t('common.to')" label-for="entry_date">
            <datepicker
              v-model="to"
              :calendar-button="true"
              :clear-button="true"
              :bootstrap-styling="true"
              class="datebtn2"
              placeholder="YYYY-MM-DD"
            />
          </b-form-group>
        </b-col>
        <b-col class="d-flex align-items-center mb-2 mb-lg-0">
          <b-button variant="primary" class="mx-2" @click="getNICUPatients()">
            {{ $t("common.search") }}
          </b-button>
          <b-button
            v-if="paymentStatus === 0 && data.length > 0"
            variant="primary"
            @click="showModalPayAll()"
          >
            {{ $t("surgery.payAllNICU") }}
          </b-button>
          <b-button
            v-if="data.length > 0"
            variant="success"
            class="mx-2"
            @click="$emit('print-account-statement', 'nicu')"
          >
            <feather-icon icon="FileTextIcon" size="16" class="mr-50" />

            {{ $t("hospital.doctor-account-statement") }}
          </b-button>
        </b-col>
      </b-row>

      <b-table
        v-if="!loading"
        :items="data"
        responsive
        :fields="tableColumns"
        primary-key="id"
        show-empty
        empty-text="No matching results found"
        class="position-relative"
      >
        <template #cell(actions)="data">
          <div class="d-flex">
            <b-button
              v-if="paymentStatus === 0"
              variant="primary"
              size="sm"
              class="mr-1"
              @click="showModal(data.item)"
            >
              {{ $t("surgery.pay-doctor") }}
            </b-button>
            <b-button
              v-if="paymentStatus === 0"
              variant="warning"
              size="sm"
              @click="showReDistributionModal(data.item)"
            >
              <feather-icon icon="RefreshCwIcon" size="14" class="mr-50" />
              {{ $t("accounting.reDistribution") }}
            </b-button>
            <span
              v-if="paymentStatus === 1"
              style="
                color: green;
                font-size: large;
                font-weight: bold;
                margin-right: 8px;
              "
            >
              {{ $t("surgery.doctor has received pay") }}
            </span>
          </div>
        </template>
        <template #cell(amount)="data">
          <span class="text-nowrap">
            {{ formatIQDCurrency(getDoctorAmount(data.item)) }}
          </span>
        </template>
        <template #cell(patient_card.patient.name)="data">
          <span class="text-nowrap">
            {{ getNestedProperty(data.item, "patient_card.patient.name", "-") }}
          </span>
        </template>
        <template #cell(patient_card.patient.phone)="data">
          <span class="text-nowrap">
            {{
              getNestedProperty(data.item, "patient_card.patient.phone", "-")
            }}
          </span>
        </template>
        <template #cell(start_time)="data">
          <span class="text-nowrap">
            {{ getNestedProperty(data.item, "start_time", "-") }}
          </span>
        </template>
      </b-table>
      <template v-if="loading">
        <div>
          <div class="d-flex justify-content-center mb-1">
            <b-spinner label="Loading..." />
          </div>
        </div>
      </template>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">
              {{ $t("common.showing") }}
              {{ (page - 1) * take + 1 }}
              {{ $t("common.to") }}
              {{ Math.min(page * take, dataCount) }}
              {{ $t("common.of") }} {{ dataCount }}
            </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
            @click="getNICUPatients()"
          >
            <b-pagination
              v-model="page"
              :total-rows="dataCount"
              :per-page="take"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BPagination,
  BSpinner,
  BModal,
  BCardText,
  BBadge,
  BFormTextarea,
} from "bootstrap-vue";
import Datepicker from "vuejs-datepicker";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BPagination,
    BSpinner,
    Datepicker,
    BModal,
    BCardText,
    BBadge,
    BFormTextarea,
    ToastificationContent,
  },
  props: {
    doctorId: {
      type: [String, Number],
      required: true,
    },
    paymentStatus: {
      type: Number,
      default: 0, // 0 for unpaid, 1 for paid
    },
  },
  data() {
    return {
      params: {
        form: {},
        path: "",
      },
      take: 10,
      loading: true,
      dataCount: 0,
      data: [],
      page: 1,
      name: "",
      from: "",
      to: "",
      payNICUPatientData: {},
      nicuTotals: {},
      // ReDistribution
      redistributionReason: "Incorrect doctor amount",
      selectedItemForRedistribution: null,
      tableColumns: [
        {
          key: "patient_card.patient.name",
          label: this.$t("hospital.patient-name"),
          sortable: true,
          class: "text-nowrap",
        },
        {
          key: "patient_card.patient.phone",
          label: this.$t("hospital.patient-phone"),
          sortable: true,
          class: "text-nowrap",
        },
        {
          key: "amount",
          label: this.$t("incubator.total-price"),
          sortable: true,
        },
        {
          key: "start_time",
          label: this.$t("incubator.start-time"),
          sortable: true,
        },
        {
          key: "actions",
          label: this.$t("common.actions"),
        },
        {
          key: "created_at",
          label: this.$t("common.created_at"),
          sortable: true,
        },
      ],
    };
  },
  watch: {
    doctorId() {
      this.getNICUPatients();
    },
    paymentStatus() {
      this.getNICUPatients();
    },
  },
  mounted() {
    this.getNICUPatients();
  },
  methods: {
    getNestedProperty(obj, path, defaultValue = "N/A") {
      try {
        const result = path
          .split(".")
          .reduce(
            (acc, part) =>
              acc && acc[part] !== undefined ? acc[part] : undefined,
            obj
          );

        // Return 0 for null, undefined, or NaN
        if (result === null || result === undefined || Number.isNaN(result)) {
          return defaultValue;
        }

        return result;
      } catch {
        return defaultValue;
      }
    },

    getDoctorAmount(item) {
      // Use total_doctor_amount from backend if available
      if (
        item.total_doctor_amount !== undefined &&
        item.total_doctor_amount !== null
      ) {
        return parseFloat(item.total_doctor_amount || 0);
      }
      // Fallback: calculate from invoice_patient_incubators array if total_doctor_amount not available
      if (
        item.invoice_patient_incubators &&
        Array.isArray(item.invoice_patient_incubators) &&
        item.invoice_patient_incubators.length > 0
      ) {
        const totalDoctorAmount = item.invoice_patient_incubators.reduce(
          (sum, invoice) => sum + parseFloat(invoice.doctor_amount || 0),
          0
        );
        return totalDoctorAmount;
      }
      // Final fallback to amount
      return parseFloat(item.amount || 0);
    },

    formatIQDCurrency(value) {
      // Create a new Intl.NumberFormat object for IQD currency
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "IQD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });

      // Format the value and return it
      return formatter.format(value);
    },

    formatDate(date) {
      if (!date) return "";
      const newDate = new Date(date);
      const year = newDate.getFullYear();
      const month = String(newDate.getMonth() + 1).padStart(2, "0");
      const day = String(newDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    async getNICUPatients() {
      this.loading = true;
      let url = `/doctor/${this.doctorId}/nicu-patients?page=${this.page}&take=${this.take}&sort=-id&filter[payment_status]=${this.paymentStatus}`;

      if (this.from) {
        url += `&from=${this.formatDate(this.from)}`;
      }
      if (this.to) {
        url += `&to=${this.formatDate(this.to)}`;
      }
      if (this.name) {
        url += `&filter[patient_card.patient.name]=${this.name}`;
      }

      await this.getList(url);
      this.dataCount =
        (this.all_data.pagination && this.all_data.pagination.total) || 0;
      this.data = this.all_data.data || [];
      // Calculate total price from data using total_doctor_amount
      const totalPrice = this.data.reduce(
        (sum, item) => sum + this.getDoctorAmount(item),
        0
      );
      this.nicuTotals = {
        total_price: totalPrice,
      };
      this.loading = false;
    },

    showModal(item) {
      this.$bvModal.show(
        `modal-pay-nicu-patient-${this.doctorId}-${this.paymentStatus}`
      );
      this.payNICUPatientData = item;
    },

    showModalPayAll() {
      this.$bvModal.show(
        `modal-pay-all-nicu-patients-${this.doctorId}-${this.paymentStatus}`
      );
    },

    payNICUPatient() {
      const data = {
        patient_card_incubator_id: this.payNICUPatientData.id,
      };
      this.params.form = data;
      this.params.path = "/payNICUDoctor";
      this.$store
        .dispatch("put", this.params)
        .then((response) => {
          // Emit payment receipt event
          this.$emit("payment-receipt", {
            type: "nicu",
            data: [this.payNICUPatientData],
            isAll: false,
          });

          this.getNICUPatients();
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "pay doctor",
              variant: "success",
              text: "Doctor has been paid successfully for this NICU patient",
            },
          });
        })
        .catch((error) => {
          if (error.response && error.response.status === 400) {
            for (const item in error.response.data) {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "validation error",
                  variant: "danger",
                  text: error.response.data[item][0],
                },
              });
            }
          }
        });
    },

    async payAllNICUPatients() {
      // Fetch all unpaid data before payment for receipt
      await this.getList(
        `/doctor/${this.doctorId}/nicu-patients?take=10000&sort=-id&filter[payment_status]=0`
      );
      const allUnpaidData = this.all_data.data || [];

      const data = {
        doctor_id: this.doctorId,
      };
      this.params.form = data;
      this.params.path = "/payNICUDoctor";
      this.$store
        .dispatch("put", this.params)
        .then(() => {
          // Emit payment receipt event with all items
          this.$emit("payment-receipt", {
            type: "nicu",
            data: allUnpaidData,
            isAll: true,
          });

          this.getNICUPatients();
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "pay doctor",
              variant: "success",
              text: "Doctor has been paid successfully for all NICU patients",
            },
          });
        })
        .catch((error) => {
          if (error.response && error.response.status === 400) {
            Object.keys(error.response.data).forEach((key) => {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "validation error",
                  variant: "danger",
                  text: error.response.data[key][0],
                },
              });
            });
          }
        });
    },

    // ReDistribution methods
    showReDistributionModal(item) {
      this.selectedItemForRedistribution = item;
      this.redistributionReason = "Incorrect doctor amount";
      this.$bvModal.show(
        `modal-redistribution-nicu-${this.doctorId}-${this.paymentStatus}`
      );
    },

    cancelReDistribution() {
      this.selectedItemForRedistribution = null;
      this.redistributionReason = "Incorrect doctor amount";
    },

    async confirmReDistribution() {
      if (!this.selectedItemForRedistribution) {
        return;
      }

      const item = this.selectedItemForRedistribution;

      // For NICU patients, use the incubator endpoint with patient_card_incubator_id
      // The item.id is the patient_card_incubator_id from the NICU patients list
      const entityId = item.id;

      if (!entityId) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: this.$t("common.error"),
            variant: "danger",
            text: "Patient card incubator ID not found",
          },
        });
        this.$bvModal.hide(
          `modal-redistribution-nicu-${this.doctorId}-${this.paymentStatus}`
        );
        return;
      }

      const data = {
        reason: this.redistributionReason || "Incorrect doctor amount",
      };

      this.params.form = data;
      // Use the incubator endpoint for NICU patients
      this.params.path = `/incubator/${entityId}/revert-distribution`;

      // Debug logging
      console.log("=== ReDistribution Debug Info ===");
      console.log("Entity ID:", entityId);
      console.log("Request Path:", this.params.path);
      console.log("Request Data:", this.params.form);
      console.log("Full Item:", item);

      try {
        const response = await this.$store.dispatch("put", this.params);
        this.$bvModal.hide(
          `modal-redistribution-nicu-${this.doctorId}-${this.paymentStatus}`
        );

        // Show success message with details from response if available
        const message =
          response?.data?.message ||
          this.$t("accounting.reDistribution-success") ||
          "Distribution reverted successfully";

        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: this.$t("common.success"),
            variant: "success",
            text: message,
          },
        });
        // Refresh data
        this.getNICUPatients();
      } catch (error) {
        this.$bvModal.hide(
          `modal-redistribution-nicu-${this.doctorId}-${this.paymentStatus}`
        );

        // Better error handling to show actual API error message
        let errorMessage =
          this.$t("common.error-occurred") || "An error occurred";

        if (error.response?.data) {
          // Check if it's a validation error object
          if (
            typeof error.response.data === "object" &&
            !error.response.data.message
          ) {
            // Handle validation errors (array of errors per field)
            const errors = [];
            Object.keys(error.response.data).forEach((key) => {
              if (Array.isArray(error.response.data[key])) {
                errors.push(...error.response.data[key]);
              } else {
                errors.push(error.response.data[key]);
              }
            });
            errorMessage = errors.join(", ");
          } else if (error.response.data.message) {
            // Handle error with message property
            errorMessage = error.response.data.message;
          } else if (typeof error.response.data === "string") {
            errorMessage = error.response.data;
          }
        }

        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: this.$t("common.error"),
            variant: "danger",
            text: errorMessage,
          },
        });
      } finally {
        this.selectedItemForRedistribution = null;
        this.redistributionReason = "Incorrect doctor amount";
      }
    },
  },
};
</script>

<style scoped>
/* CSS */
</style>
